import styled from 'styled-components';
import { makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';

export const useStyles = makeStyles({
  mb30: {
    marginBottom: '30px'
  },
  input: {
    backgroundColor: '#FFFFFF',
    borderRadius: '15px',
    width: '100%',
    boxShadow: '5px 5px rgba(60,128,209,0.09)'
  },
  popupTitle: {
    padding: '44px 56px 0 56px'
  },
  popupTitleText: {
    fontWeight: 'bold',
    fontSize: '17px'
  },
  popupContent: {
    padding: '0 56px 0px 56px',
    fontSize: '14px'
  },
  popupButton: {
    justifyContent: 'center',
    paddingBottom: '30px'
  },
  formLabelOption: {
    display: 'block'
  },
  forgotPasswordWrapper: {
    ['@media (max-width: 768px)']: {
      display: 'flex',
      justifyContent: 'center'
    }
  }
});

export const FormLabel = styled.p`
  color: #102341;
  font-family: 'TTCommons';
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 18px;
  margin-bottom: 5px;
`;

export const ErrorMessage = styled.p`
  color: #ed5a5a;
  font-family: 'TTCommons';
  font-size: 20px;
  margin-left: 14px;
  margin-right: 14px;
  font-weight: 400;
  line-height: 1.66;
  margin-top: 3px;
`;

export const TextInBoldRegister = styled.p`
  color: #617799;
  font-family: 'TTCommons';
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  margin-top: 15px;
`;

export const TextInBoldForgot = styled.p`
  color: #4c7cfd;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 18px;
  font-family: 'TTCommons';
  margin-top: 15px;
  margin-bottom: 20px;
  width: fit-content;
`;

export const LinkWrapper = styled(Link)`
  text-decoration: none;
  color: #4c7cfd;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 18px;
  font-family: 'TTCommons';
  margin-top: 15px;
  margin-bottom: 20px;
  width: fit-content;
  display: block;
  outline: none;
  &:focus {
    color: #0066ff;
  }
`;

export const LinkWithoutMargin = styled(Link)`
  text-decoration: none;
  color: #4c7cfd;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 18px;
  font-family: 'TTCommons';
  width: fit-content;
  display: inline-block;
  outline: none;
  &:focus {
    color: #0066ff;
  }
`;
